import React from "react";

const Skill = ({ title }) => {
  return (
    <h5 className="py-2 px-4 md:px-6  bg-gray_100 hover:bg-[#2b2b2b] text-sm md:text-lg font-semibold text-center rounded-md  transition-all delay-100">
      {title}
    </h5>
  );
};

export default Skill;
